import React, { Component } from "react";
import {
  Responsive,
  Sidebar,
  Menu,
  Segment,
  Icon,
  Image,
} from "semantic-ui-react";
import ContentContainer from "./ContentContainer";
import logoOriginal from "./../static/logo_original.png";
import { navigateToSection } from "./../js";

const getWidth = () => {
  const isSSR = typeof window === "undefined";

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

class MobileContainer extends Component {
  state = {
    logo: logoOriginal,
    sidebarOpened: false,
  };

  handleSidebarHide = () => {
    this.setState({ sidebarOpened: false });
    document.body.style.overflow = "";
  };

  handleToggle = () => this.setState({ sidebarOpened: true });

  handleSidebarShow = () => (document.body.style.overflow = "hidden");

  handleClick = (section) => {
    this.handleSidebarHide();
    navigateToSection(section);
  };

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation="push"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
          onShow={this.handleSidebarShow}
        >
          <Menu.Item as="a" onClick={() => this.handleClick("section-home")}>
            <span>Home</span>
          </Menu.Item>
          <Menu.Item as="a" onClick={() => this.handleClick("section-empresa")}>
            Empresa
          </Menu.Item>
          <Menu.Item
            as="a"
            onClick={() => this.handleClick("section-produtos")}
          >
            Produtos
          </Menu.Item>
          <Menu.Item as="a" onClick={() => this.handleClick("section-imagens")}>
            Imagens
          </Menu.Item>
          <Menu.Item as="a" onClick={() => this.handleClick("section-contato")}>
            Contato
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign="center"
            style={{ maxHeight: "1428px", padding: "0em 0em", margin: "0" }}
            vertical
          >
            <Menu
              fixed="top"
              inverted
              pointing
              secondary
              size="small"
              style={{ backgroundColor: "#f0f2ec", margin: 0 }}
            >
              <Menu.Item onClick={this.handleToggle}>
                <Image
                  src={this.state.logo}
                  alt="logo-varais-alpha"
                  style={{ width: 40, height: 25 }}
                />
              </Menu.Item>
              <Menu.Menu position="right">
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name="sidebar" size="big" color="black" />
                </Menu.Item>
              </Menu.Menu>
            </Menu>
            <ContentContainer mobile={true} />
          </Segment>
        </Sidebar.Pusher>

        {children}
      </Responsive>
    );
  }
}

export default MobileContainer;
